/**
 * Created by Max on 31/03/2021.
 */


class SimpleTable extends React.Component{
	render = () => {
		const {
			classe,
			entetes,
			lignes
		} = this.props;

		return (
			<Table className={classe} bordered hover>
				<thead>
				{entetes.map((entete, key) => (
					<th key={key}>{entete}</th>
				))}
				</thead>

				<tbody>
				{lignes.map((ligne, key) => (
					<tr key={key}>
						{ligne.map((cell, key) => (
							<td key={key}>{cell}</td>
						))}
					</tr>
				))}
				</tbody>
			</Table>
		)
	}
}